import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=3a350e07&scoped=true"
import script from "./Risk.vue?vue&type=script&lang=js"
export * from "./Risk.vue?vue&type=script&lang=js"
import style0 from "./Risk.vue?vue&type=style&index=0&id=3a350e07&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a350e07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a350e07')) {
      api.createRecord('3a350e07', component.options)
    } else {
      api.reload('3a350e07', component.options)
    }
    module.hot.accept("./Risk.vue?vue&type=template&id=3a350e07&scoped=true", function () {
      api.rerender('3a350e07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/Risk.vue"
export default component.exports